import React, { useState, useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import swal from 'sweetalert2';
import Slider from 'react-slick';
import moment from 'moment';
import LeaveRecDetail from '../../LeaveRecDetail';
import axios from 'axios';

import '../../../scss/components/pages/signin-management.scss';

import API from '../../../middleware/API';
import {GetStoreRole,GetStoreDetailRole} from '../../../const/constant';
import Pagination from '../../Pagination';
import { buildOvertimeRange } from '../../util/overtimeTime';
import AddWorkTimeInSignInShiftBlock from '../../AddWorkTimeInSignInShiftBlock';
import EditWorkTimeInSignInShiftBlock from '../../EditWorkTimeSignInShiftBlock';
import ReAddWordTimeInSignInShiftBlock from '../../ReAddWordTimeInSignInShiftBlock';
import ProxyOvertime from '../../ProxyOvertime';
import Table from '../../Table';
import ReviewOvertime from '../../ReviewOvertime'
import FillLeave from '../../FillLeave'


function SigningManagement() {
  const countOfPage = 10;
  const editType = 'ADD';
  const start = `${moment().add(0, 'month').format('YYYY-MM')}-01`;
  const end = moment(start).add(1, 'month').add(-1, 'days').format('YYYY-MM-DD');
  const [isEditShow, setIsEditShow] = useState (false);
  const [isloading, setIsLoading] = useState (false);
  const [editTarget, setEditTarget] = useState ({});

  const [currPage, setCurrPage] = useState(1);
  const [staffList, setStaffList] = useState([]);
  const [leaveTypeList, setLeaveTypeList] = useState([]);
  const [searchName, setSearchName] = useState('');
  const [attendance, setAttendance] = useState({ count: 0, records: [] });
  const [isLeaveRecDetailDisplay, toggleLeaveRecDetail] = useState(false);
  const [reload, doReload] = useState(false);
  const [targetLeaveRec, setTargetLeaveRec] = useState({});
  const [editOvertime, setEditOvertime] = useState({
    id: -1,
    eventId:-1,
    proxyUserId:-1,
    startAt:moment(),
    endAt:moment(),
    reason:'',
    pay:0,
    overTimeHours:0,
    notes:'',
    status:'1',
    payType:'-1',
    isPartTime:true,
    hasRest: false
  });
  const [fillLeave, setFillLeave] = useState({
    id: -1,
    eventId:-1,
    leaveItemId:0,
    agentUserId:0,
    sDate:moment(),
    eDate:moment(),
    reasons:'',
    status:'1',
    leaveHours:0,
    isPartTime:true,
    hasRest: false
  });
  const [isAddWorkTimeOpen, setIsAddWorkTimeOpen] = useState(false);
  const [isEditWorkTimeOpen, setIsEditWorkTimeOpen] = useState(false);
  const [isReAddWorkTimeOpen, setIsReAddWorkTimeOpen] = useState(false);
  const [isProxyOvertimeOpen, setIsProxyOvertimeOpen] = useState(false);
  const [isFillLeaveOpen, setIsFillLeaveOpen] = useState(false);
  const [isRequestComplete, setIsRequestComplete] = useState(true);
  //const [isHistoryBlockOpen, setIsHistoryBlockOpen] = useState(false);
  const [reAddWorkTimeInformation, setReAddWorkTimeInformation] = useState({});
  const [targetEventId, setTargetEventId] = useState(-1);
  const [editTargetDate, setEditTargetDate] = useState('');
  const [isPartTime, setIsPartTime] = useState(false);
  const [remainHours, setRemainHours] = useState(0);
  const [compensatoryHours, setCompensatoryHours] = useState(0);
  const [signingCompensatoryHours, setSigningCompensatoryHours] = useState(0);
  const [signingAnnualHours, setSigningAnnualHours] = useState(0);
  const [eventId, setEventId] = useState(0);
  const [expectedDateToModify, setExpectedDateToModify] = useState('');
  const [editStaff, setEditStaff] = useState({
    expectedDate: moment(),
    expectedStart: moment(),
    expectedEnd: moment(),
  });
  const role =  GetStoreRole(localStorage.getItem('current_store_id'))  ;
  const detailrole =  GetStoreDetailRole(localStorage.getItem('current_store_id'))  ;
  // 加班「新增」按鈕可見性：3、8 一律不可；11 只在當天尚無加班單時可（避免重複建單，其簽核／作廢權限維持不變，見下方三元鏈）；其他角色可
  const canAddOvertime = (overTimeData) => {
    if (detailrole === '3' || detailrole === '8') return false;
    if (detailrole === '11') return overTimeData.length === 0;
    return true;
  };

  function loadData() {
    const params = {
      timeOffset: 8,
      start,
      end,
      page: currPage,
      pageSize: countOfPage,
      isSign: true,
    };
    if (searchName) params.keyword = searchName;
      
        axios.all([
          API.get('/Event/AttendanceSheet/All', {
                params,
          }),
          API.get('/User/All'),
          API.get('/Leave')
        ])
          .then(axios.spread((eventList, staffList, leaveTypeList) => {
            if(eventList)
            {
              setAttendance(eventList);
              setIsLoading(false)
              setIsReAddWorkTimeOpen(false)

              if(targetEventId !== -1){
                setReAddWorkTimeInformation(refactorItem(eventList.records.find(m=>m.eventId === targetEventId)))
              }
            }
            if (staffList) {          
              setStaffList(staffList);
            }   
            if (leaveTypeList) {          
              setLeaveTypeList(leaveTypeList)
            }      
        }));

    // API.get('/Event/AttendanceSheet/All', {
    //   params,
    // }).then((response) => {
    //   if (response) {
    //     setAttendance(response);
    //     setIsLoading(false)
    //     setIsReAddWorkTimeOpen(false)

    //     if(targetEventId !== -1){
    //       setReAddWorkTimeInformation(refactorItem(response.records.find(m=>m.eventId === targetEventId)))
    //     }
    //   }
    // });
  }

  // useEffect(
  //   ()=>{API.get('/User/All').then((response) => {
  //     if (response) {
  //       setStaffList(response);
  //     }
  //   })}
  // ,[]);

  useEffect(
    loadData,
    [currPage, reload],
  );


  useEffect(() => {
    const timeOutId = setTimeout(() => {
      handleInputChange(searchName);
      loadData()
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchName]);


  function handleInputChange(searchName) {
    setCurrPage(1);
    setSearchName(searchName);
  }

  function handleChangePage(page) {
    setCurrPage(page);
  }
  const signingRecNew = (id, status, comment, payType) => {
    //後端會根據是否為兼職強制修改payType
    let data = {
      overTimeIds: id,
      status: status,
      note: comment,
      payType: payType,
    }
    API.put('OverTime/Signing', data).then((res) => {
      if (res) {
        if(status === 'X')
          swal({type:'success',title:'作廢成功'})
        else
          swal({type:'success',title:'簽核成功'})
        setIsEditShow(false);
        doReload(!reload);    
      }
    });             
  };
  const updateLeaveHours = (key,e)=>{
    setEditTarget({...editTarget,leaveHours:e.target.value});
  }
  function handleDeleteButton({
    id, type, totalWorkTime, isSign,
  }) {
    swal({
      type,
      title: '是否確認刪除該筆資料',
      showConfirmButton: true,
      showCloseButton: true,
      confirmButtonText: '確定',
      heightAuto: false,
    }).then((result) => {
      if (result.value !== undefined) {
        const urlAPI = '/Event';
        const data = { data:{Id: id}};

        API.delete(urlAPI, data).then((response) => {
          if (response) {
            setSearchName('');
            loadData();
          }else{
            swal({
              type:'error',
              title:'無法刪除',
              text:'該事件有假單或加班單或者已被簽核過',
              showConfirmButton: true,
              showCloseButton: true,
              confirmButtonText: '確定',
              heightAuto: false
            })
          }
        });
      }
    });
  }
  function refactorItem(item) {
    console.log(item.expectedSignInTime)
    let newItem = {
      id: item.id,
      name: item.name,
      typeId: item.typeId,
      jobType: item.jobType,
      eventId: item.eventId,
      expectedDate: item.expectedDate,
      expectedSignInTime: item.expectedSignInTime,
      expectedSignOutTime: item.expectedSignOutTime,
      firstSignId: item.data[0] ? item.data[0].id : '無資料',
      firstSignIntime: item.data[0] ? item.data[0].actualSignInTime : '無資料',
      firstSignOuttime: item.data[0] ? item.data[0].actualSignOutTime : '無資料',

      secondSignId: item.data[1] ? item.data[1].id : '無資料',
      secondSignIntime: item.data[1] ? item.data[1].actualSignInTime : '無資料',
      secondSignOuttime: item.data[1] ? item.data[1].actualSignOutTime : '無資料',

      thirdSignId: item.data[2] ? item.data[2].id : '無資料',
      thirdSignIntime: item.data[2] ? item.data[2].actualSignInTime : '無資料',
      thirdSignOuttime: item.data[2] ? item.data[2].actualSignOutTime : '無資料',
    totalHours: timeStringToFloatHour(item.totalWorkTime),
      expectedTotalHours: getTimeDiffInHours(item.expectedSignInTime, item.expectedSignOutTime),

    }
    return newItem;
  }
function timeStringToFloatHour(timeStr) {
  const [h, m] = timeStr.split(':').map(Number);
  return h + (m / 60);
}
function makeupRestTime(item) {
  console.log(item);
  
  if(item>= 3.5 && item <7){
    return item+=0.5
  }else if(item >= 7){
    return item+=1
  }
}

  function handleSignInButton({
    id, userId,  type, isSign, totalWorkTime, totalHours, expectedTotalHours,leaveData
  }) {

    let status = 3;
    let text = `同意實際簽到退時間(扣除休息):${ReactDOMServer.renderToStaticMarkup(totalWorkTime)}`;
    switch (type) {
      case 'success':
        status = 1;
        break;
      case 'error':
        status = 2;
        text = '不同意實際簽到退時間';
        break;
      case 'info':
        text = '員工請假';
        break;
      default:
        break;
    }
    text += '<br/>';
    text += '<select id="mySelect">';
    text += '<option value="">請選擇</option>';
    text += '<option value="遲到">遲到</option>';
    text += '<option value="生理假">生理假</option>';
    text += '<option value="人力不足">人力不足</option>';
    text += '<option value="提早上班">提早上班</option>';
    text += '<option value="提早下班">提早下班</option>';
    text += '<option value="延後上班">延後上班</option>';
    text += '<option value="延後下班">延後下班</option>';
    text += '<option value="提早上班+提早下班">提早上班+提早下班</option>';
    text += '<option value="提早上班+延後下班">提早上班+延後下班</option>';
    text += '<option value="延後上班+提早下班">延後上班+提早下班</option>';
    text += '<option value="延後上班+延後下班">延後上班+延後下班</option>';
    text += '<option value="遲到+提早下班">遲到+提早下班</option>';
    text += '<option value="遲到+延後下班">遲到+延後下班</option>';
    text += '<option value="病假">病假</option>';
    text += '<option value="事假">事假</option>';
    text += '<option value="喪假">喪假</option>';
    text += '<option value="開會">開會</option>';
    text += '<option value="換班">換班</option>';
    text += '<option value="員工調換班">員工調換班</option>';
    text += '<option value="上班漏打卡">上班漏打卡</option>';
    text += '<option value="海大支援">海大支援</option>';
    text += '</select>';



    if(leaveData.length > 0){
      text = `<span style="color:red">員工有假單</span><br/>` +
        leaveData.map(
          leave =>
        `<div>
          <b>${leave.leaveTypeName || ''}</b>
          ${leave.sDate.split('T')[1]} ~ ${leave.eDate.split('T')[1] }
          ${leave.status === '1' ? '<span style="color:green">(已簽核)</span>' : leave.status === 'S' ? '<span style="color:orange">(待簽核)</span>' : '<span style="color:gray">(已作廢)</span>'}
        </div>`
        ).join('') + '----------------------<br/>'+
        text;
    }

    if (makeupRestTime(totalHours) < expectedTotalHours) { 
      type = 'warning';
      text = '<span style=color:red>打卡時數('+makeupRestTime(totalHours).toFixed(2)+'小時)小於排班時數('+expectedTotalHours+'小時)</span><br/>----------------------<br/>'+text;
    }

    swal({
      type,
      html: text,
      inputPlaceholder: '輸入備註(選填)',
      input: 'text',
      showConfirmButton: true,
      showCloseButton: true,
      confirmButtonText: '確定',
      heightAuto: false,
    }).then((result) => {
      if (result.value !== undefined) {
        const adminName = localStorage.getItem('adminName') || '';
        const urlAPI = isSign ? '/Event/Update' : '/Event/Sign';

        var e = document.getElementById("mySelect");
        var strUser = e.options[e.selectedIndex].value;
        
        const data = { eventId: id, userId:userId, status, comment: result.value ? `${adminName}:${strUser}-${result.value}` : `${adminName}:${strUser}` };
        setIsLoading(true)
        API.post(urlAPI, data).then((response) => {
          console.log(response)
          if (response == 1) {
            setSearchName('');

            loadData();
          }else{
                    setIsLoading(false)

            swal({
              type:'error',
              title:'無法簽核',
              text:response,
              showConfirmButton: true,
              showCloseButton: true,
              confirmButtonText: '確定',
              heightAuto: false
            })
          }
        });
      }
    });
  }

  function styleTime(strTime) {
    return <span style={{ color: '#dddddd' }}>{strTime}</span>;
  }

  function styleTotalWorkTime(arrTotalWorkTime) {
    const styleHightLight = {
      color: arrTotalWorkTime[0] > 9 ? 'red' : '#4A4A4A',
      fontWeight: arrTotalWorkTime[0] > 9 ? '900' : '400',
      fontSize: arrTotalWorkTime[0] > 9 ? '20px' : '18px',
    };
    const strHour = arrTotalWorkTime[0] < 10
      ? `0${arrTotalWorkTime[0]}`
      : arrTotalWorkTime[0];
    const strMinutes = arrTotalWorkTime[1] < 10
      ? `0${arrTotalWorkTime[1]}`
      : arrTotalWorkTime[1];
    return (
      <span style={styleHightLight}>
        {`${strHour}時${strMinutes}分`}
      </span>
    );
  }

  function leaveRecBtn(leaveRec){
      const statusClass = leaveRec.status === '1'
        ? 'success'
        : leaveRec.status === 'S'
          ? 'slide-bar-font-color-active'
          : 'cancel';
      const statusText = leaveRec.status === '1'
        ? '已簽核'
        : leaveRec.status === 'S'
          ? '待簽核'
          : '已作廢';
      const statusHint = leaveRec.status === '1'
        ? '提醒：此假單已簽核通過'
        : leaveRec.status === 'S'
          ? '提醒：此假單尚待簽核'
          : '提醒：此假單已作廢';

      return (
        <button
          key={leaveRec.id}
          type="button"
          className={`btn btn-md ${statusClass}`}
          style={{ width:'120px', display: 'block', margin: '4px 0' }}
          title={statusHint}
          onClick={() => {
            toggleLeaveRecDetailDisplay(
              leaveRec,
            );
          }}
        >
          <span>{`假單(${statusText})`}</span>
        </button>
      );
  }

  function toggleLeaveRecDetailDisplay(leaveRec) {
    if (isLeaveRecDetailDisplay){
      setTargetLeaveRec({});
    }else{
      setTargetLeaveRec(leaveRec);
    }
    toggleLeaveRecDetail(!isLeaveRecDetailDisplay)
  }

  function handleCancelLeaveRec(leaveRec) {
    swal({
      type: 'warning',
      title: '確認作廢此假單？',
      input: 'text',
      inputPlaceholder: '輸入備註(選填)',
      showConfirmButton: true,
      showCloseButton: true,
      confirmButtonText: '確定',
      heightAuto: false,
    }).then((result) => {
      if (result.value !== undefined) {
        const request = {
          leaveIds: leaveRec.id,
          status: 'X',
          note: result.value || '',
          leaveHours: leaveRec.leaveHours || 0,
        };
        API.put('LeaveRec/Signing', request).then((response) => {
          if (response) {
            swal({ type: 'success', title: '作廢成功' });
            setTargetLeaveRec({});
            toggleLeaveRecDetail(false);
            loadData();
          }
        });
      }
    });
  }

  function handleEditLeaveRec(leaveRec) {
    setTargetEventId(leaveRec.eventId || -1);
    setEditTargetDate(moment(leaveRec.sDate).format('YYYY-MM-DD'));
    setIsPartTime(typeof leaveRec.isPartTime === 'boolean' ? leaveRec.isPartTime : true);
    setRemainHours(leaveRec.remainHours || 0);
    setCompensatoryHours(leaveRec.compensatoryHours || 0);
    setSigningCompensatoryHours(0);
    setSigningAnnualHours(0);

    setFillLeave({
      id: leaveRec.id,
      eventId: leaveRec.eventId || -1,
      leaveItemId: leaveRec.leaveItemId || 0,
      agentUserId: leaveRec.agentUserId || (leaveRec.agentUser ? leaveRec.agentUser.id : 0),
      sDate: leaveRec.sDate ? moment(leaveRec.sDate).format('YYYY-MM-DDTHH:mm') : moment(),
      eDate: leaveRec.eDate ? moment(leaveRec.eDate).format('YYYY-MM-DDTHH:mm') : moment(),
      reasons: leaveRec.reasons || '',
      status: leaveRec.status || '1',
      leaveHours: leaveRec.leaveHours || 0,
      isPartTime: typeof leaveRec.isPartTime === 'boolean' ? leaveRec.isPartTime : true,
      hasRest: false,
      notes: leaveRec.notes || '',
      fileName: leaveRec.fileName || '',
    });

    setTargetLeaveRec({});
    toggleLeaveRecDetail(false);
    setIsFillLeaveOpen(true);
  }

  function handleToggleOpenAddWorkTimeBlockV2(item) {
    if(role !== '2' && role !== '5')
      return;
    var staff = [];
    staff.push(
      {
        realName:item.name,
        expectedDate:item.expectedDate,
        expectedStart:item.expectedSignInTime.length === 0 ? '無':item.expectedSignInTime,
        expectedEnd:item.expectedSignOutTime.length === 0 ? '無':item.expectedSignOutTime,
        
      }
    )
    let newEditHoliday = {
      expectedDate:item.expectedDate,
      expectedStart:item.expectedSignInTime.length === 0 ? '無':item.expectedSignInTime,
      expectedEnd:item.expectedSignOutTime.length === 0 ? '無':item.expectedSignOutTime,
    };
    setEditStaff(
      newEditHoliday
    );

    setStaffList(staff)
    setEventId(item.eventId)
    setExpectedDateToModify(item.expectedDate)
    setIsEditWorkTimeOpen(true)
  }
  function handleToggleOpenAddWorkTimeBlock() {
    setIsAddWorkTimeOpen(!isAddWorkTimeOpen)
  }
  function handleSaveFillLeaveFunc(data) {

    let {id, leaveItemId, sDate, eDate, agentUserId, reasons, leaveHours} = fillLeave;
    let requestType = id > 0 ? 'EDIT' : 'ADD';
    console.log(fillLeave)
    let request = {
        id: id,
        leaveItemId: leaveItemId,
        sDate: sDate,
        eDate: eDate,
        agentUserId: agentUserId,
        reasons: reasons,
        leaveHours: leaveHours,
        status: '1',
        eventId: fillLeave.eventId || targetEventId,
    }
    if(data){
      var formData = new FormData();
      formData.append("PicFile", data);
      axios.post('https://wisdombank.liangshishu.com/member/api/FileUploader/CafeLeavePic', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        if(res.data.indexOf('Error') !== -1)
        {
          swal({type:'error',title:'檔案上傳失敗，請重新再試'});
          return;
        }
        request.fileName = res.data.split('/')[res.data.split('/').length-1];

        if (requestType === 'ADD'){
            API.post('Leave/Proxy', request).then((response) => {
              console.log(response)
                if (response == 1) {
                    handleFillLeaveInformation();
                    loadData();
                }else{
                  swal({type:'error',title:'該時段已有其他假單'})
                }
              });
        }else{
            API.put('Leave/AdminPut/'+request.id, request).then((response) => {
                            console.log(response)

                if (response == 1) {
                    swal({type:'success',title:'修改成功'})

                    handleFillLeaveInformation();
                    loadData();
                }else{
                  swal({type:'error',title:'該時段已有其他假單'})
                }
              });
        }

      });
    }else{
        if (requestType === 'ADD'){
            API.post('Leave/Proxy', request).then((response) => {
                            console.log(response)

                if (response == 1) {
                    handleFillLeaveInformation();
                    loadData();
                }else{
                  swal({type:'error',title:'該時段已有其他假單'})
                }
              });
        }else{
            API.put('Leave/AdminPut/'+request.id, request).then((response) => {
                            console.log(response)

                if (response == 1) {
                  swal({type:'success',title:'修改成功'})

                    handleFillLeaveInformation();
                    loadData();
                }else{
                  swal({type:'error',title:'該時段已有其他假單'})
                }
              });
        }
    }
    
  }
  function handleReAddWorkTimeInformation(item) {
    setTargetEventId(item.eventId);
    console.log(item)

    let newItem = {
      id: item.id,
      name: item.name,
      jobType: item.jobType,
      eventId: item.eventId,
      isPartTime: item.isPartTime,
      expectedDate: item.expectedDate,
      expectedSignInTime: item.expectedSignInTime,
      expectedSignOutTime: item.expectedSignOutTime,
      expectedSignIntime: item.expectedSignInTime.length === 0 ? '00:00':item.expectedSignInTime, //for彈跳視窗
      expectedSignOuttime: item.expectedSignOutTime.length === 0 ? '23:59':item.expectedSignOutTime,//for彈跳視窗
      firstSignId: item.data[0] ? item.data[0].id : '無資料',
      firstSignIntime: item.data[0] ? item.data[0].actualSignInTime : '無資料',
      firstSignOuttime: item.data[0] ? item.data[0].actualSignOutTime : '無資料',

      secondSignId: item.data[1] ? item.data[1].id : '無資料',
      secondSignIntime: item.data[1] ? item.data[1].actualSignInTime : '無資料',
      secondSignOuttime: item.data[1] ? item.data[1].actualSignOutTime : '無資料',

      thirdSignId: item.data[2] ? item.data[2].id : '無資料',
      thirdSignIntime: item.data[2] ? item.data[2].actualSignInTime : '無資料',
      thirdSignOuttime: item.data[2] ? item.data[2].actualSignOutTime : '無資料',

      firstStartPosition: item.data[0] ? item.data[0].actualSignInPosition : null,
      firstEndPosition: item.data[0] ? item.data[0].actualSignOutPosition : null,

      secondStartPosition: item.data[1] ? item.data[1].actualSignInPosition : null,
      secondEndPosition: item.data[1] ? item.data[1].actualSignOutPosition : null,

      thirdStartPosition: item.data[2] ? item.data[2].actualSignInPosition : null,
      thirdEndPosition: item.data[2] ? item.data[2].actualSignOutPosition : null,
    //totalHours: timeStringToFloatHour(item.totalWorkTime),
      expectedTotalHours: getTimeDiffInHours(item.expectedSignInTime, item.expectedSignOutTime),

    }
    

    setReAddWorkTimeInformation(newItem);
    handleToggleOpenReAddWorkTimeBlock();
  }

  function handleToggleOpenReAddWorkTimeBlock() {
    if(isReAddWorkTimeOpen){
      setTargetEventId(-1);
    }
    setIsReAddWorkTimeOpen(!isReAddWorkTimeOpen)
  }
  // function handleToggleOpenHistoryBlock() {
  //   setIsHistoryBlockOpen(!isHistoryBlockOpen)
  // }
//ActualEvent
  function addPunchTimeRecord(data){
    setIsRequestComplete(false);
    API.post('/ActualEvent', data).then((response) => {
      if (response) {
        swal({type:'success',title:'新增成功'}).then(()=>{
          setIsRequestComplete(true);
          doReload(!reload);
          handleToggleOpenReAddWorkTimeBlock();
        })
      }
    })
  }

  function handleOnChangeInput(key,val){
    // 若不小心傳入 event，取 value
    if (val && val.target) val = val.target.value;

    // 改為淺拷貝，避免 JSON.stringify 序列化 DOM 或 circular 結構
    let newObj = { ...editOvertime };

    if(key === 'payType')
      newObj.payType = val;
    
    if(key=='hasRest'){
      if(val == 1)
        newObj.hasRest= true;
      else
        newObj.hasRest = false;
    }

    if(key === 'reason')
      newObj.reason = val;

    if(key === 'notes'){
      newObj.notes = val;
    }
      
    if(key === 'startAt'){
      newObj.startAt = val;
      newObj.endAt = moment(newObj.endAt);
    }
    else if(key === 'endAt'){
      newObj.startAt = moment(newObj.startAt);
      newObj.endAt = val;
    }
    else{
      newObj.startAt = moment(newObj.startAt);
      newObj.endAt = moment(newObj.endAt);
    }
    setEditOvertime(newObj);
  }
  function diff (start, end)  {
    start = start.split(":");
    end = end.split(":");
    let startDate = new Date(0, 0, 0, start[0], start[1], 0);
    let endDate = new Date(0, 0, 0, end[0], end[1], 0);
    let diff = endDate.getTime() - startDate.getTime();
    let hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    let minutes = Math.floor(diff / 1000 / 60);

    // If using time pickers with 24 hours format, add the below line get exact hours
    if (hours < 0)
       hours = hours + 24;

    if(hours + (minutes/60) > 8){
      return 8;
    }    
    return hours + (minutes/60);
  }
  function handleFillLeaveOnChangeInput(key, e) {
    // 取出真正值（支援 event 或直接傳值）
    const getValue = (v) => {
      if (v && v.target) return v.target.value;
      return v;
    };

    // 建立淺拷貝
    let newObj = Object.assign({}, fillLeave);

    const val = getValue(e);

    // 協助：把 moment 或 字串統一成 'YYYY-MM-DDTHH:mm' 格式字串
    const toDateTimeString = (input) => {
      if (moment.isMoment(input)) return input.format('YYYY-MM-DDTHH:mm');
      if (!input) return '';
      // 若已經是 'YYYY-MM-DDTHH:mm' 或 'YYYY-MM-DDTHH:mm:ss'，只取前 16 chars
      if (typeof input === 'string') {
        if (input.indexOf('T') !== -1) return input.split('.')[0].slice(0,16);
        // 可能是日期只有 YYYY-MM-DD
        if (/^\d{4}-\d{2}-\d{2}$/.test(input)) return input + 'T00:00';
      }
      return '';
    };

    if (key === 'eDate' || key === 'sDate') {
      // val 可能是 moment 或 格式化字串
      newObj[key] = toDateTimeString(val);
    } else if (key === 'reasons' || key === 'notes') {
      newObj[key] = val || '';
    } else if (key === 'workingHours' || key === 'leaveHours') {
      // 數字欄位
      const n = Number(val);
      newObj[key] = Number.isNaN(n) ? 0 : n;
    } else {
      // 其他（例如 agentUserId, leaveItemId）
      const maybeNum = Number(val);
      newObj[key] = Number.isNaN(maybeNum) ? (val || '') : maybeNum;
    }

    // --- 重要：統一把 sDate/eDate 轉成字串後再計算 leaveHours ---
    const sStr = toDateTimeString(newObj.sDate);
    const eStr = toDateTimeString(newObj.eDate);
    if (sStr && eStr) {
      try {
        // 覆寫成標準字串，確保 state 一致
        newObj.sDate = sStr;
        newObj.eDate = eStr;
        const sTime = sStr.split('T')[1].slice(0,5);
        const eTime = eStr.split('T')[1].slice(0,5);
        newObj.leaveHours = diff(sTime, eTime);
      } catch (err) {
        // 不中斷流程
      }
    }

    setFillLeave(newObj);
  }


  function handleSaveStaff(dropReason){
    // 加班單不處理跨日，開始與結束時間一律固定在申請日期當天
    const range = buildOvertimeRange(editOvertime, 'HH:mm:ss');
    if (!range) {
      swal({type:'error', title:'加班時間有誤，請重新選擇', heightAuto:false});
      return;
    }
    let newObj = Object.assign({}, editOvertime);
    newObj.status = '1';
    newObj.startAt = range.startAt;
    newObj.endAt = range.endAt;
    newObj.reason = (dropReason === '-1'? '' : dropReason) + (newObj.reason ? ' - '+newObj.reason:'');

    setIsRequestComplete(false);
    API.post('/Overtime/Proxy', newObj).then((response) => {
      if (response) {
        swal({type:'success',title:'新增成功'}).then(()=>{
          setIsRequestComplete(true);
          doReload(!reload);
          handleOverTimeInformation();
        })
      }
    })
  }
  function toggleFillLeaveShow(){
    setIsFillLeaveOpen(!isFillLeaveOpen)
  }
  function handleFillLeaveInformation(item) {
    if(isFillLeaveOpen){
      setTargetEventId(-1);
      setEditTargetDate('');
      setIsPartTime(false);
      setRemainHours(0);
      setCompensatoryHours(0);
      setSigningCompensatoryHours(0);
      setSigningAnnualHours(0);
      setFillLeave({
          id: -1,
          eventId:-1,
          leaveItemId:0,
          agentUserId:0,
          sDate:moment(),
          eDate:moment(),
          reasons:'',
          status:'1',
          leaveHours:0,
          isPartTime:true,
          hasRest: false
      })
    }else{
const expectedIn = item.expectedSignInTime && item.expectedSignInTime !== '' ? item.expectedSignInTime : (item.firstSignInTime || '');
      const expectedOut = item.expectedSignOutTime && item.expectedSignOutTime !== '' ? item.expectedSignOutTime : (item.firstSignOutTime || '');
let initialLeaveHours = 0;
      if (expectedIn && expectedOut && expectedIn.indexOf(':') !== -1 && expectedOut.indexOf(':') !== -1) {
        initialLeaveHours = diff(expectedIn, expectedOut);
      }

      setTargetEventId(item.eventId);
      setEditTargetDate(item.expectedDate);
      setIsPartTime(item.isPartTime);
      setRemainHours(item.remainHours);
      setCompensatoryHours(item.compensatoryHours);
      setSigningCompensatoryHours(item.signingCompensatoryHours);
      setSigningAnnualHours(item.signingAnnualHours);
      let sDate, eDate;
      if (item.data && item.data.length > 0) {
        const validSignInTimes = item.data.filter(d => d.actualSignInTime).map(d => moment(item.expectedDate + 'T' + d.actualSignInTime));
        const validSignOutTimes = item.data.filter(d => d.actualSignOutTime).map(d => moment(item.expectedDate + 'T' + d.actualSignOutTime));
        if (validSignInTimes.length > 0 && validSignOutTimes.length > 0) {
          sDate = moment.min(validSignInTimes);
          eDate = moment.max(validSignOutTimes);
        }
      }
      if (!sDate) {
        sDate = item.expectedSignInTime !== "" ? moment(item.expectedDate+'T'+item.expectedSignInTime) : moment(item.expectedDate+'T'+item.firstSignInTime);
      }
      if (!eDate) {
        eDate = item.expectedSignOutTime !== "" ? moment(item.expectedDate+'T'+item.expectedSignOutTime) : moment(item.expectedDate+'T'+item.firstSignOutTime);
      }
      let fillLeave= {
        eventId:item.eventId,
        agentUserId:0,
        leaveItemId:0,
        isPartTime: item.isPartTime,
        sDate,
        eDate,
        date:item.expectedDate,
        reasons:'',
        leaveHours:initialLeaveHours,
      }
      

      setFillLeave(fillLeave);
    
    }
    toggleFillLeaveShow();
  }
  function toggleEditBlockShow(){
    setIsProxyOvertimeOpen(!isProxyOvertimeOpen)
  }
  function handleOverTimeInformation(item) {
    if(isProxyOvertimeOpen){
      setTargetEventId(-1);
    }else{
      setTargetEventId(item.eventId);
      let editOvertime= {
        eventId:item.eventId,
        proxyUserId:item.id,
        isPay:false,
        pay:item.pay,
        payType:item.payType,
        isPartTime: item.isPartTime,
        startAt:item.expectedSignInTime !== ""?moment(item.expectedDate+'T'+item.expectedSignInTime):moment(item.expectedDate+'T'+item.firstSignInTime),
        endAt:item.expectedSignOutTime !== ""?moment(item.expectedDate+'T'+item.expectedSignOutTime):moment(item.expectedDate+'T'+item.firstSignOutTime),
        date:item.expectedDate,
        reason:'',
        notes:'',
        hasRest: false
      }
      

      setEditOvertime(editOvertime);
    
    }
    toggleEditBlockShow();
  }
  function editPunchTimeRecord(data){
    setIsRequestComplete(false);

    console.log(data)
    if(data.IsExpectedEvent)
    {
      let request = {
        id : data.Id,
        start: expectedDateToModify + ' ' + data.StartAt.split('T')[1],
        end: expectedDateToModify + ' ' + data.EndAt.split('T')[1],
        resourceId : 6
      }
      API.patch('/Event',request).then((response) => {
        swal({type:'success',text:'修改成功'})
        setIsRequestComplete(true);
        doReload(!reload);
        handleToggleOpenReAddWorkTimeBlock();

      });
    }
    else
    {
      API.put('/ActualEvent', data).then((response) => {
        if (response) {
          swal({type:'success',title:'編輯成功'}).then(()=>{
            setIsRequestComplete(true);
            doReload(!reload);
            handleToggleOpenReAddWorkTimeBlock();
          })
        }
      })
    }

  }
  function handleEditStaffWorkRecord(item) {
    let request = {
      id : eventId,
      start: expectedDateToModify + ' ' + item.start.split(' ')[1],
      end: expectedDateToModify + ' ' + item.end.split(' ')[1],
      resourceId : item.resourceId
    }
    API.patch('/Event',request).then((response) => {
      swal({type:'success',text:'修改成功'})
      doReload(!reload);
    });
  }
  function handleAddStaffWorkRecord(data) {    
    setIsRequestComplete(false);
    API.post('/Event/Adjust?timeOffset=8', data).then((response) => {
      console.log(response)
      if (response.success) {
        setIsRequestComplete(true);
        swal({type:'success',title:'新增成功'})
        doReload(!reload);
      }else{
        setIsRequestComplete(true);
        swal({type:'error',title:'新增失敗',text:response})
        doReload(!reload);

      }
    })
  }
function getTimeDiffInHours(start, end) {
  // 解析時間字串
  const [startH, startM] = start.split(':').map(Number);
  const [endH, endM] = end.split(':').map(Number);

  // 轉換成分鐘
  const startTotal = startH * 60 + startM;
  const endTotal = endH * 60 + endM;

  // 若跨日，補24小時
  let diff = endTotal - startTotal;
  if (diff < 0) diff += 24 * 60;

  // 轉換成小時（浮點數）
  return diff / 60;
}

  function getRowStyle({ isSign, data }, arrTotalWorkTime) {
    const objStyle = {};
    const reducer = (final, now) => (final
        && now.actualSignInTime !== null
        && now.actualSignOutTime !== null);
    const buckyreducer = (final, now) => (final
      && now.actualSignInTime !== ''
      && now.actualSignOutTime !== '');
    if (isSign) {
      objStyle.backgroundColor = '#FA8072';
    } else if (arrTotalWorkTime[0] > 9) {
      objStyle.backgroundColor = '#fac472';
    } else if (!data.reduce(reducer, true)) {
      objStyle.backgroundColor = '#fac472';
    } else if (!data.reduce(buckyreducer, true)) {
      objStyle.backgroundColor = '#fac472';
    }
    return objStyle;
  }
  function deletePunchTimeRecord(eventId){
    swal({
      type:'info',
      title: '是否確認刪除該筆資料',
      showConfirmButton: true,
      showCloseButton: true,
      confirmButtonText: '確定',
      heightAuto: false,
    }).then((result) => {
      if (result.value !== undefined) {
        API.delete('/ActualEventById/'+eventId).then((response) => {
          if (response) {
            setTargetEventId(-1);
            swal({type:'success',title:'刪除成功'}).then(()=>{
              doReload(!reload);
              //handleToggleOpenReAddWorkTimeBlock();
            })
          }
        })
      }
    });

  }
  const showMap = (position)=>{
    let text = '<iframe width="100%" height="300" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?q=' + position.split(',')[1] +','+ position.split(',')[0] +'&hl=zh-TW&z=14&amp;output=embed"></iframe>'
    swal({
      html: text,
      showConfirmButton: true,
      showCloseButton: false,
      confirmButtonText: '確定',
      heightAuto: false,
    });
  }
  const strNoDate = 'N/A';
  const unscheduledNotice = <span style={{ color: 'red', fontWeight: 'bold' }}>無排班，無法簽核</span>;
  const { count, records } = attendance;
  const totalPage = Math.ceil(count / countOfPage);
  const newRecords = records.map((item) => {
    const arrTotalWorkTime = item.totalWorkTime.split(':');
    const newItem = {
      ...item,
      firstSignId: item.data[0] ? item.data[0].id : strNoDate,
      firstSignInTime: item.data[0] ? item.data[0].actualSignInTime : styleTime(strNoDate),
      firstSignOutTime: item.data[0] ? item.data[0].actualSignOutTime : styleTime(strNoDate),
      firstStartPosition: item.data[0] ? item.data[0].actualSignInPosition : null,
      firstEndPosition: item.data[0] ? item.data[0].actualSignOutPosition : null,

      secondSignId: item.data[1] ? item.data[1].id : strNoDate,
      secondSignInTime: item.data[1] ? item.data[1].actualSignInTime : styleTime(strNoDate),
      secondSignOutTime: item.data[1] ? item.data[1].actualSignOutTime : styleTime(strNoDate),
      secondStartPosition: item.data[1] ? item.data[1].actualSignInPosition : null,
      secondEndPosition: item.data[1] ? item.data[1].actualSignOutPosition : null,

      thirdSignId: item.data[2] ? item.data[2].id : strNoDate,
      thirdSignInTime: item.data[2] ? item.data[2].actualSignInTime : styleTime(strNoDate),
      thirdSignOutTime: item.data[2] ? item.data[2].actualSignOutTime : styleTime(strNoDate),
      thirdStartPosition: item.data[2] ? item.data[2].actualSignInPosition : null,
      thirdEndPosition: item.data[2] ? item.data[2].actualSignOutPosition : null,
      totalWorkTime: styleTotalWorkTime(arrTotalWorkTime),
      rowStyle: getRowStyle(item, arrTotalWorkTime),
      isEmptySign: item.data.length === 0,
      showAddOvertime: !item.isUnscheduled && canAddOvertime(item.overTimeData),
      totalHours: timeStringToFloatHour(item.totalWorkTime),
      expectedTotalHours: getTimeDiffInHours(item.expectedSignInTime, item.expectedSignOutTime),
    };
    return newItem;
  });
  const settings = {
    dots: true,
    arrows: false,
  };

  const columns = [
    {
      title:'姓名',
      field:'name',
      property: false,
    },
    {
      title:'上班日',
      field:'expectedDate',
      property: false,
      render: (props) => (
        //<div onDoubleClick={()=>{handleToggleOpenAddWorkTimeBlockV2(props)} }>
        <div>
        <span style={{color: props.isHoliday ? 'red' : ''  }}>
          {props.expectedDate}</span>
            </div>
      )
    },
    {
      title:'預期簽到退',
      field:'expectsignupoff',
      property: false,
      render: (props) => (
        //<div onDoubleClick={()=>{handleToggleOpenAddWorkTimeBlockV2(props)} }>
        <div>
        {props.isUnscheduled && <div>{unscheduledNotice}</div>}
        <span style={{ color: props.expectedSignInTime.length === 0 ? 'red' : '' }}>
          {props.expectedSignInTime.length === 0 ? "無":props.expectedSignInTime}</span>  ~ 
          <span style={{ color: props.expectedSignOutTime.length === 0 ? 'red' : '' }}>
            {props.expectedSignOutTime.length === 0 ? "無":props.expectedSignOutTime}</span>
            </div>
      )
    },
    {
      title:'簽到退一',
      field:'signupoff1',
      property: false,
      render: (props) => (
        <>
        {props.firstSignInTime}{
                props.firstStartPosition ?
              <button onClick={()=>showMap(props.firstStartPosition)}>地圖</button>:''
              } ~ {props.firstSignOutTime}{
                props.firstEndPosition ?
              <button onClick={()=>showMap(props.firstEndPosition)}>地圖</button>:''
              }
        </>
      )
    },
    {
      title:'簽到退二',
      field:'signupoff2',
      property: false,
      render: (props) => (
        <>
        {props.secondSignInTime} {
                props.secondStartPosition ?
              <button onClick={()=>showMap(props.secondStartPosition)}>地圖</button>:''
              }~ {props.secondSignOutTime}{
                props.secondEndPosition ?
              <button onClick={()=>showMap(props.secondEndPosition)}>地圖</button>:''
              }
        </>
      )
    },
    {
      title:'簽到退三',
      field:'signupoff3',
      property: false,
      render: (props) => (
        <>
        {props.thirdSignInTime} {
                props.thirdStartPosition ?
              <button onClick={()=>showMap(props.thirdStartPosition)}>地圖</button>:''
              }~ {props.thirdSignOutTime}{
                props.thirdEndPosition ?
              <button onClick={()=>showMap(props.thirdEndPosition)}>地圖</button>:''
              }
        </>
      )
    },
    {
      title:'總時數',
      field:'totalWorkTime',
      property: false
    },
    {
      title:'算薪工時',
      field:'totalSalaryTime',
      property: false,
      render: (props) => (
        <>
        {props.totalSalaryTime} 小時
        </>
      )
    },
    {
      title:'修改',
      field:'status',
      property: false,
      render: (props) => (
        !props.isUnscheduled &&
        <button className="btn edit btn-md" onClick={() => { handleReAddWorkTimeInformation(props); } }>編輯</button>

      ),
    },
    {
      title:'加班',
      field:'overtime',
      property: false,
      render: (props) => (
        props.overTimeData.length > 0 && props.overTimeData[0].status == '1'?
        <button className="btn success btn-md" onClick={() => { 
          var overtimeData = props.overTimeData[0];
          var payStr = 
          overtimeData.payType === 1 ? '補休'+overtimeData.compensatoryHours+'小時'
          :overtimeData.payType === 2 ?'加班費'+overtimeData.amt+'元'
          :overtimeData.payType === 3 ?'休假日加班費'+overtimeData.amt+'元'
          :overtimeData.payType === 5 ?'國定假日'+overtimeData.amt+'元 + 補休'+overtimeData.compensatoryHours+'小時'
          :'國定假日'+overtimeData.amt+'元';

          var swalObj = {
            type: 'info',
            title: '加班單',
            html:overtimeData.startAt.split('T')[1]+'~'+overtimeData.endAt.split('T')[1]+'<br/>'+ overtimeData.overtimeHours + '小時'+'<br/>' + payStr+'<br/>' +props.overTimeData[0].reason,
            confirmButtonColor: '#FF0000',
            showConfirmButton: false,
            showCancelButton: true,
            heightAuto: false,
            width: '250px',
            //confirmButtonText: '作廢',
            cancelButtonText: '關閉',
          };
          
  if(detailrole != '3' && detailrole != '8' && detailrole != '11'){
    swalObj.showConfirmButton =  true;
    swalObj.confirmButtonText = '作廢';
  }
   


          swal(swalObj).then((result) => {
            if (result.value) {
              let data = {
                overTimeIds: overtimeData.id,
                status: 'X',
                note: '',
                leaveHours: 0
            }
        
            API.put('OverTime/Signing', data).then((res) => {
                if (res) {
                  swal({type: 'success',
                  title: '作廢成功',}).then(()=>{
                    doReload(!reload);

                  })
                  }
              });   

            }
          });
        } }>查看</button>
        :
        props.overTimeData.length > 0 && props.overTimeData[0].status == 'S'&& (detailrole != '3' && detailrole != '8' && detailrole != '11')?
        <button className="btn success btn-md" onClick={() => { 
          var overtimeData = props.overTimeData[0];

          setIsEditShow(true)
          setEditTarget(overtimeData)
        } }>簽核</button>
        :
        props.overTimeData.length > 0 && props.overTimeData[0].status == 'X'&& (detailrole != '3' && detailrole != '8' && detailrole != '11')?
        <button className="btn btn-md delete" style={{width:'115px'}} onClick={() => { 
          let newObj = JSON.parse(JSON.stringify((props.overTimeData[0])));
          console.log(newObj)
          newObj.startAt=moment(newObj.startAt);
          newObj.endAt=moment(newObj.endAt);
          newObj.payType = newObj.payType 
          setEditOvertime(newObj);
          
          
          toggleEditBlockShow();
        } }>編輯作廢</button>
        :
        !props.showAddOvertime ? '':
         <button className="btn slide-bar-font-color-active btn-md" onClick={() => { handleOverTimeInformation(props); } }>新增</button>       

      ),
    },
    {
      title:'假單',
      field:'leave',
      property: false,
      render: (props) => (
        <div>
          {
            props.leaveData.length > 0 && props.leaveData.map(leaveRecBtn)
          }
          {!props.isUnscheduled && <button style={{width:'100px', display: 'block', margin: '4px 0'}} className="btn slide-bar-font-color-active btn-md" onClick={() => { handleFillLeaveInformation(props); } }>新增假單</button>}
        </div>
      ),
    },
    {
      title:'簽核',
      field:'sign',
      property: false,
      render: (props) => (
        props.isUnscheduled ? unscheduledNotice :
        <>
        <button
        type="button"
        className="btn save btn-md"
        style={{ display: props.leaveData.length === 0 && props.firstSignId === strNoDate && props.secondSignId === strNoDate && props.thirdSignId === strNoDate ? 'none' : '' }}
        onClick={() => {
          handleSignInButton({
            id: props.eventId,
            userId: props.id,
            type: 'success',
            isSign: props.isSign,
            totalWorkTime: props.totalWorkTime,
            totalHours: props.totalHours,
            expectedTotalHours: props.expectedTotalHours,
            leaveData: props.leaveData,
          });
        }}
      >
        <span>同意</span>
      </button>
      {
        props.isEmptySign ?
        (
          <button
            type="button"
            className="btn delete btn-md"
            onClick={() => {
              handleDeleteButton({
                id: props.eventId,
                type: 'error',
                isSign: props.isSign,
                totalWorkTime: props.totalWorkTime,
              });
            }}
          >
            <span>刪除</span>
          </button>
      ):
      ''
      }
      
      </>
      ),
    },
    {
      title:'備註',
      field:'comment',
      property: false,
    },
  ];
  if (isloading) {
    return (
      <div className="loading__overlay">
        <div className="loading__content">
          <div className="spinner" />
          <h1>資料下載中</h1>
        </div>
      </div>
    );
  }


  return (
    <div className="p-signInManagement">
      <div className="u-block">
        <div className="u-title">
          <span>簽核管理</span>
          <a
            href="https://docs.google.com/presentation/d/1FHnvWFHZmGKuzusrMraGE9PRYETn7EhJnRv93bdvdLs/edit#slide=id.p"
            className="u-how-use"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fas fa-question-circle" />
          </a>
        </div>
        <div className="sign-notice">
          <div className="u-notice">*公司規定之休息時間:</div>
          <div className="u-notice">(1) 填班4小時以下不休息</div>
          <div className="u-notice">(2) 填班4小時＜工時＜8小時，則休息半小時</div>
          <div className="u-notice">(3) 填班8小時＜＝工時＜12小時，則休息一小時</div>
          <div className="u-notice">(4) 填班12小時＜＝工時，則休息二小時</div>
          <div className="u-notice">*溫馨提醒: </div>
          <div className="u-notice">1.請檢查是否有需要補簽或新增員工上班紀錄再簽核，若需要請加上備註。</div>
          <div className="u-notice">2.注意！沒有簽核之資料將不會顯示在會計「核薪專用簽到退」表中，將會影響員工的權益。</div>
          <div className="u-notice">3.<button
              type="button"
              className={`btn btn-md success`}
            >假單</button>表示已簽核通過，<button
              type="button"
              className={`btn btn-md slide-bar-font-color-active`}
            >假單</button>表示尚未簽核<button
            type="button"
            className={`btn btn-md cancel`}
          >假單</button>表示已做廢。</div>
          <div className="u-notice">4.算新工時=打卡時間+加班單時間。</div>

        </div>
        <br />
        <div className="u-search-box">
        <button className="btn btn-md main-color" onClick={handleToggleOpenAddWorkTimeBlock}>新增員工上班紀錄</button>

          <div className="u-search-box_right">
            <div className="date-input m-l-8">
              <input
                name="searchNameInput"
                className="u-form__input"
                value={searchName}
                placeholder="請輸入姓名"
                onChange={event => setSearchName(event.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="u-table-media">
        <Table columns={columns} datas={newRecords} fullHeight={true} overHidden={false}/>
        </div>

          {/* <table className="u-table u-table-border u-table-striped u-table-media">
            <thead>
              <tr>
                <th>姓名</th>
                <th>上班日</th>
                <th>預期簽到退</th>
                <th>簽到退一</th>
                <th>簽到退二</th>
                <th>簽到退三</th>
                <th>總時數</th>
                <th>修改</th>
                <th>簽核</th>
                <th>備註</th>
              </tr>
            </thead>
            <tbody>
              {
                newRecords.map((item, index) => (
                  <tr key={index} style={item.rowStyle}>
                    <td>{item.name}</td>
                    <td>{item.expectedDate}</td>
                    <td><span style={{ color: item.expectedSignInTime.length === 0 ? 'red' : '' }}>{item.expectedSignInTime.length === 0 ? "無":item.expectedSignInTime}</span>  ~ <span style={{ color: item.expectedSignOutTime.length === 0 ? 'red' : '' }}>{item.expectedSignOutTime.length === 0 ? "無":item.expectedSignOutTime}</span> </td>
                    <td>{item.firstSignInTime} ~ {item.firstSignOutTime}</td>
                    <td>{item.secondSignInTime} ~ {item.secondSignOutTime}</td>
                    <td>{item.thirdSignInTime} ~ {item.thirdSignOutTime}</td>
                    <td>{item.totalWorkTime}</td>
                    <td>
                      <button className="btn edit btn-md" onClick={() => { handleReAddWorkTimeInformation(item); } }>編輯</button>
                    </td>
                    <td className="text-align-left">
                      <button
                        type="button"
                        className="btn save btn-md"
                        style={{ display: item.leaveData.length === 0 && item.firstSignId === strNoDate && item.secondSignId === strNoDate && item.thirdSignId === strNoDate ? 'none' : '' }}
                        onClick={() => {
                          handleSignInButton({
                            id: item.eventId,
                            userId: item.id,
                            type: 'success',
                            isSign: item.isSign,
                            totalWorkTime: item.totalWorkTime,
                          });
                        }}
                      >
                        <span>同意</span>
                      </button>
                      {
                        item.leaveData.length > 0 ? 

                        item.leaveData.map(leaveRecBtn,this)
                          :
                          ''}
                      {
                        item.isEmptySign ?
                        (
                          <button
                            type="button"
                            className="btn delete btn-md"
                            onClick={() => {
                              handleDeleteButton({
                                id: item.eventId,
                                type: 'error',
                                isSign: item.isSign,
                                totalWorkTime: item.totalWorkTime,
                              });
                            }}
                          >
                            <span>刪除</span>
                          </button>
                      ):
                      ''
                      }

                    </td>
                    <td>{item.comment}</td>
                  </tr>
                ))
              }
            </tbody>
          </table> */}

          <Slider {...settings}>
            {
              newRecords.map((item, index) => (
                <div key={index}>
                  <table className="u-table u-table-border u-table-media-phone">
                    <tbody style={item.rowStyle}>
                      <tr>
                        <th>姓名</th>
                        <td>{item.name}</td>
                      </tr>
                      <tr>
                        <th>上班日</th>
                        <td>{item.expectedDate}</td>
                      </tr>
                      {item.isUnscheduled && (
                        <tr>
                          <th>排班</th>
                          <td>{unscheduledNotice}</td>
                        </tr>
                      )}
                      <tr>
                        <th>預期簽到</th>
                        <td>{item.expectedSignInTime.length === 0 ? "無":item.expectedSignInTime}</td>
                      </tr>
                      <tr>
                        <th>預期簽退</th>
                        <td>{item.expectedSignOutTime.length === 0 ? "無":item.expectedSignOutTime}</td>
                      </tr>
                      <tr>
                        <th>簽到一</th>
                        <td>{item.firstSignInTime}</td>
                      </tr>
                      <tr>
                        <th>簽退一</th>
                        <td>{item.firstSignOutTime}</td>
                      </tr>
                      <tr>
                        <th>簽到二</th>
                        <td>{item.secondSignInTime}</td>
                      </tr>
                      <tr>
                        <th>簽退二</th>
                        <td>{item.secondSignOutTime}</td>
                      </tr>
                      <tr>
                        <th>簽到三</th>
                        <td>{item.thirdSignInTime}</td>
                      </tr>
                      <tr>
                        <th>簽退三</th>
                        <td>{item.thirdSignOutTime}</td>
                      </tr>
                      <tr>
                        <th>總時數</th>
                        <td>{item.totalWorkTime}</td>
                      </tr>
                      <tr>
                        <th>算薪工時</th>
                        <td>{item.totalSalaryTime} 小時</td>
                      </tr>
                      <tr>
                        <th>加班</th>
                        <td>
                          {
                          item.overTimeData.length > 0 && item.overTimeData[0].status == '1'?
                          <button className="btn success btn-md" onClick={() => { 
                            var overtimeData = item.overTimeData[0];
                            var payStr = 
                            overtimeData.payType === 1 ? '補休'+overtimeData.compensatoryHours+'小時'
                            :overtimeData.payType === 2 ?'加班費'+overtimeData.amt+'元'
                            :overtimeData.payType === 3 ?'休假日加班費'+overtimeData.amt+'元'
                            :overtimeData.payType === 5 ?'國定假日'+overtimeData.amt+'元 + 補休'+overtimeData.compensatoryHours+'小時'
                            :'國定假日'+overtimeData.amt+'元';

                            var swalObj = {
                              type: 'info',
                              title: '加班單',
                              html:overtimeData.startAt.split('T')[1]+'~'+overtimeData.endAt.split('T')[1]+'<br/>'+ overtimeData.overtimeHours + '小時'+'<br/>' + payStr,
                              showConfirmButton: false,
                              confirmButtonColor: '#FF0000',
                              showCancelButton: true,
                              heightAuto: false,
                              width: '250px',
                              //confirmButtonText: '作廢',
                              cancelButtonText: '關閉',
                            };


                            if(detailrole != '3' && detailrole != '8' && detailrole != '11'){
                              swalObj.showConfirmButton =  true;
                              swalObj.confirmButtonText = '作廢';
                            }
                              
                            
                            swal(swalObj).then((result) => {
                              if (result.value) {
                                let data = {
                                  overTimeIds: overtimeData.id,
                                  status: 'X',
                                  note: '',
                                  leaveHours: 0
                              }

                              API.put('OverTime/Signing', data).then((res) => {
                                  if (res) {
                                    swal({type: 'success',
                                    title: '作廢成功',}).then(()=>{
                                      doReload(!reload);

                                    })
                                    }
                                });   

                              }
                            });
                          } }>查看</button>
                          :
                          item.overTimeData.length > 0 && item.overTimeData[0].status == 'S' && (detailrole != '3' && detailrole != '8' && detailrole != '11')?
                          <button className="btn success btn-md" onClick={() => { 
                            var overtimeData = item.overTimeData[0];

                            setIsEditShow(true)
                            setEditTarget(overtimeData)
                          } }>簽核</button>
                          :
                          item.overTimeData.length > 0 && item.overTimeData[0].status == 'X' && (detailrole != '3' && detailrole != '8' && detailrole != '11')?
                          <button className="btn btn-md delete" style={{width:'115px'}} onClick={() => { 
                            // var editOverTimeData = item.overTimeData[0];
                            // console.log(editOverTimeData)
                            // let newObj = JSON.parse(JSON.stringify((editTarget)));

                            // newObj.id = editOverTimeData.id;
                            // newObj.eventId = item.id;
                            // newObj.applyDate = item.expectedDate;
                            // newObj.expectSignInTime = item.expectedDate+'T' + item.expectedSignInTime;
                            // newObj.expectSignOutTime = item.expectedDate+'T' + item.expectedSignOutTime;
                            // newObj.startAt=moment(editOverTimeData.startAt);
                            // newObj.endAt=moment(editOverTimeData.endAt);
                            // newObj.reason=editOverTimeData.reason;
                            // newObj.date=item.expectedDate;
                            // newObj.notes = editOverTimeData.notes
                            // newObj.pay=item.pay
                            // newObj.overTimeHours = editOverTimeData.overTimeHours

                            // setEditTarget(newObj)
                            // setIsEditShow(true)
                            let newObj = JSON.parse(JSON.stringify((item.overTimeData[0])));
                            console.log(newObj)
                            newObj.startAt=moment(newObj.startAt);
                            newObj.endAt=moment(newObj.endAt);
                            newObj.payType = newObj.payType 
                            setEditOvertime(newObj);
                            
                            
                            toggleEditBlockShow();
                          } }>編輯作廢</button>
                          :
                          !item.showAddOvertime ? '':
                          <button className="btn slide-bar-font-color-active btn-md" onClick={() => { handleOverTimeInformation(item); } }>新增</button>
                          }
                        </td>
                      </tr>
                      <tr>
                        <th>假單</th>
                        <td>
                          <div>
                            {
                              item.leaveData.length > 0 && item.leaveData.map(leaveRecBtn)
                            }
                            {!item.isUnscheduled && <button className="btn slide-bar-font-color-active btn-md" style={{ width:'100px', display: 'block', margin: '4px 0' }} onClick={() => { handleFillLeaveInformation(item); } }>新增假單</button>}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-align-center" colSpan="2">
                          {item.isUnscheduled ? unscheduledNotice : <>
                          <button
                            type="button"
                            className="btn save btn-md m-l-16"
                            style={{ display:  item.leaveData.length === 0 && item.firstSignId === strNoDate && item.secondSignId === strNoDate && item.thirdSignId === strNoDate ? 'none' : '' }}
                            onClick={() => {
                              handleSignInButton({
                                id: item.eventId,
                                userId: item.id,
                                type: 'success',
                                isSign: item.isSign,
                                totalWorkTime: item.totalWorkTime,
                                totalHours: item.totalHours,
                                expectedTotalHours: item.expectedTotalHours,
                                leaveData: item.leaveData,
                              });
                            }}
                          >
                            <span>同意</span>
                          </button>
                          <button className="btn edit btn-md m-l-16" onClick={() => { handleReAddWorkTimeInformation(item); } }>編輯</button>
                          {
                            item.isEmptySign ?
                            (
                              <button
                                type="button"
                                className="btn delete btn-md m-l-16"
                                onClick={() => {
                                  handleDeleteButton({
                                    id: item.eventId,
                                    type: 'error',
                                    isSign: item.isSign,
                                    totalWorkTime: item.totalWorkTime,
                                  });
                                }}
                              >
                                <span>刪除</span>
                              </button>
                          ):(
                              ''
                            )

                          }
                          </>}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))
            }
          </Slider>
        <div className="pagination-box">
          <Pagination
            currPage={currPage}
            totalPage={totalPage}
            onChangPage={handleChangePage}
          />
        </div>
        <LeaveRecDetail 
            leaveRec={targetLeaveRec}
            isShow={isLeaveRecDetailDisplay}
            toggleFunc={toggleLeaveRecDetailDisplay}
            onEdit={handleEditLeaveRec}
            onCancel={handleCancelLeaveRec}
            canEdit={targetLeaveRec && targetLeaveRec.status !== 'X'}
            canCancel={targetLeaveRec && targetLeaveRec.status !== 'X'}
          />
        <AddWorkTimeInSignInShiftBlock 
          isVisible={isAddWorkTimeOpen} 
          toggleOpen={handleToggleOpenAddWorkTimeBlock} 
          allStaff={staffList}
          isRequestComplete={isRequestComplete}
 
          saveWorkRecordFunc={handleAddStaffWorkRecord}
        />
        <EditWorkTimeInSignInShiftBlock
          isSalaryEdit={true}
          isVisible={isEditWorkTimeOpen} 
          toggleOpen={()=>{setIsEditWorkTimeOpen(false)}} 
          allStaff={staffList}
          isRequestComplete={isRequestComplete}
          editStaff={editStaff}
          saveWorkRecordFunc={handleEditStaffWorkRecord}
        />
        <ReAddWordTimeInSignInShiftBlock 
          isVisible={isReAddWorkTimeOpen} 
          toggleOpen={handleToggleOpenReAddWorkTimeBlock} 
          staffRecord={reAddWorkTimeInformation}
          searchStartDate={moment(start)}
          searchEndDate={moment(end)}
          isRequestComplete={isRequestComplete}

          addPunchTimeFunc={addPunchTimeRecord}
          editPunchTimeFunc={editPunchTimeRecord}
          deletePunchTimeFunc={deletePunchTimeRecord}

          page={currPage}
        />

        <ProxyOvertime
          editType={editType}
          isShow={isProxyOvertimeOpen}
          editInformation={editOvertime}
          onChangeFunc={handleOnChangeInput}
          saveFunc={handleSaveStaff}
          toggleFunc={handleOverTimeInformation}
        />
        <FillLeave 
          isVisible={isFillLeaveOpen} 
          toggleOpen={handleFillLeaveInformation} 
          targetDate = {editTargetDate} 
          allStaff={staffList} 
          editTarget={fillLeave}
          allLeaveType={leaveTypeList} 
          saveWorkRecordFunc={handleSaveFillLeaveFunc}
          targetEventId={targetEventId}
          onChangeFunc={handleFillLeaveOnChangeInput}
          longLeave={false}
          dateDisabled
          remainHours = {remainHours- signingAnnualHours}
          compensatoryHours = {compensatoryHours- signingCompensatoryHours}
        />
        <ReviewOvertime 
          isVisible={isEditShow} 
          toggleOpen={()=>{setIsEditShow(!isEditShow);}} 
          editTarget={editTarget}
          isProxy={true}
          signingFunc={signingRecNew}
          onChangeFunc={updateLeaveHours}
        />
        
{/*
        <SignInOutEditHistory 
          isVisible={isHistoryBlockOpen} 
          toggleOpen={handleToggleOpenHistoryBlock} 
          record={this.props.SignInOutHistoryState}
          historyName={this.state.historyName}
        /> */}
      </div>
    </div>
  );
}

export default SigningManagement;
